module.exports = __webpack_public_path__ + "static/media/blog2.2718a9f1.png";